"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _AppBar = _interopRequireDefault(require("@mui/material/AppBar"));

var _Divider = _interopRequireDefault(require("@mui/material/Divider"));

var _Drawer = _interopRequireDefault(require("@mui/material/Drawer"));

var _Hidden = _interopRequireDefault(require("@mui/material/Hidden"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _Toolbar = _interopRequireDefault(require("@mui/material/Toolbar"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _styles = require("@mui/styles");

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MuiNavbar = function MuiNavbar(_ref) {
  var _navbar, _appBarHeight;

  var height = _ref.height,
      background = _ref.background,
      navItemPosition = _ref.navItemPosition,
      logoTextColor = _ref.logoTextColor,
      logo = _ref.logo,
      logoText = _ref.logoText,
      togglerColor = _ref.togglerColor,
      children = _ref.children;
  var drawerWidth = 200;
  var theme = (0, _material.useTheme)();
  var useStyles = (0, _styles.makeStyles)({
    root: {
      display: 'flex',
      background: background || theme.palette.primary.main
    },
    navLogoText: {
      color: theme.palette.primary.main,
      textAlign: 'center',
      margin: '1rem .3rem'
    },
    logoImg: {
      padding: '1rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    navbar: (_navbar = {}, _defineProperty(_navbar, theme.breakpoints.down('md'), {
      display: 'none !important'
    }), _defineProperty(_navbar, "display", 'flex'), _defineProperty(_navbar, "alignItems", 'center'), _defineProperty(_navbar, "minHeight", height || 64), _navbar),
    appBar: _defineProperty({
      background: "".concat(background || theme.palette.primary.main, " !important")
    }, theme.breakpoints.up('md'), {
      width: '100%',
      display: 'none !important'
    }),
    menuButton: _defineProperty({
      marginRight: theme.spacing(2)
    }, theme.breakpoints.up('md'), {
      display: 'none'
    }),
    drawerPaper: {
      width: drawerWidth,
      background: "".concat(background || theme.palette.primary.main, " !important")
    },
    mobileMenu: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start'
    },
    appBarHeight: (_appBarHeight = {
      height: height || 64,
      background: 'transparent',
      width: '100%'
    }, _defineProperty(_appBarHeight, theme.breakpoints.down('sm'), {
      height: 48
    }), _defineProperty(_appBarHeight, theme.breakpoints.up('md'), {
      display: 'none'
    }), _appBarHeight)
  });

  var _useStyles = useStyles(),
      root = _useStyles.root,
      appBar = _useStyles.appBar,
      menuButton = _useStyles.menuButton,
      drawerPaper = _useStyles.drawerPaper,
      navbar = _useStyles.navbar,
      mobileMenu = _useStyles.mobileMenu,
      appBarHeight = _useStyles.appBarHeight;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      mobileOpen = _useState2[0],
      setMobileOpen = _useState2[1];

  var handleDrawerToggle = function handleDrawerToggle() {
    setMobileOpen(!mobileOpen);
  };

  var drawer = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, logo ? /*#__PURE__*/_react["default"].createElement("img", {
    src: logo,
    style: {
      maxWidth: '90%',
      maxHeight: 80,
      margin: '20px auto'
    },
    alt: "Logo"
  }) : /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    style: {
      margin: '20px auto',
      color: logoTextColor || '#fff'
    },
    variant: "h6"
  }, logoText || ''), (logo || logoText) && /*#__PURE__*/_react["default"].createElement(_Divider["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
    className: mobileMenu
  }, children));

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: root
  }, /*#__PURE__*/_react["default"].createElement(_AppBar["default"], {
    className: appBar
  }, /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "inherit",
    "aria-label": "open drawer",
    edge: "start",
    onClick: handleDrawerToggle,
    className: menuButton
  }, /*#__PURE__*/_react["default"].createElement("div", null, _toConsumableArray(Array(3)).map(function (e, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      style: {
        width: 25,
        height: 3,
        backgroundColor: togglerColor || '#fff',
        margin: '4px 0'
      }
    });
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: appBarHeight
  }), /*#__PURE__*/_react["default"].createElement("nav", null, /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
    mdUp: true,
    implementation: "css"
  }, /*#__PURE__*/_react["default"].createElement(_Drawer["default"], {
    variant: "temporary",
    open: mobileOpen,
    onClose: handleDrawerToggle,
    classes: {
      paper: drawerPaper
    },
    ModalProps: {
      keepMounted: true
    }
  }, drawer))), /*#__PURE__*/_react["default"].createElement(_material.Container, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: navbar
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: 1
    }
  }, logo ? /*#__PURE__*/_react["default"].createElement("img", {
    src: logo,
    style: {
      maxWidth: 250,
      maxHeight: 55
    },
    alt: "Logo"
  }) : /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h6",
    style: {
      color: logoTextColor || '#fff'
    }
  }, logoText || '')), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: 3,
      textAlign: navItemPosition || 'right'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, children)))));
};

var _default = MuiNavbar;
exports["default"] = _default;